import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import { Button, QuantityPicker } from "..";
import theme, { media } from "../../theme";

const QUANTITY_BUTTON_HEIGHT = 40;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const QuantityWrapper = styled.div`
  display: flex;
  height: ${QUANTITY_BUTTON_HEIGHT}px;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  border: solid 1px ${theme.colors.black};
  padding: 0 10px 0 15px;
  background-color: ${theme.colors.white};

  ${media.laptop} {
    padding: 0;
  }
`;

export interface IProps {
  className?: string;
  fullWidth: boolean;
  loading?: boolean;
  onClick: () => void;
  onQuantitySelect: (quantity: number) => void;
  quantity: number;
  title: string;
}

type IDefaultProps = Required<Pick<IProps, "className" | "loading">>;

export default class QuantityButton extends PureComponent<
  IProps,
  {},
  IDefaultProps
> {
  public static defaultProps: IDefaultProps = {
    className: "",
    loading: false,
  };

  public render(): ReactNode {
    const {
      className,
      quantity,
      onQuantitySelect,
      onClick,
      title,
      fullWidth,
      loading,
    } = this.props;

    return (
      <Wrapper className={className}>
        <QuantityWrapper>
          <QuantityPicker
            excludeZero
            quantity={quantity}
            onSelect={onQuantitySelect}
          />
        </QuantityWrapper>
        <Button
          onClick={onClick}
          title={title}
          fullWidth={fullWidth}
          height={QUANTITY_BUTTON_HEIGHT}
          loading={loading}
        />
      </Wrapper>
    );
  }
}
